export function validEmail(email) {
  return String(email)
    .toLowerCase()
    .match(/^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/);
}

export function validCloudEmail(email) {
  return String(email)
    .toLowerCase()
    .match(/^([a-zA-Z0-9_.+-])+@cloud\.statcan\.ca/);
}
